let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8JshA")).then(() => parcelRequire('3M9k7'));